import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  photo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  container: {
    marginTop: theme.spacing.sm
  },

  name: {
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '20px'
  },

  email: {
    color: theme.colors.brandGray[0],
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '17px',
    marginTop: theme.spacing.xs
  },
  ldapLabel: {
    width: 'fit-content',
    margin: '0 auto',
    backgroundColor: 'rgba(51, 154, 240, 1)',
    color: '#EFF8FF',
    padding: '3px 4px',
    borderRadius: '16px',
    fontWeight: '500',
    fontSize: '10px',
    lineHeight: '100%',
    letterSpacing: '0%',
    flexShrink: 0
  },
  badge: {
    marginTop: theme.spacing.sm
  }
}));
